import { style } from "@vanilla-extract/css";
import { breakpoints, vars } from "plos/src/styles";

export const elementRemoveButton = style({
  display: "none",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: vars.radii.full,
  backgroundColor: vars.colors.primaryFixed,
  width: 16,
  height: 16,
  color: vars.colors.white,

  "@media": {
    [`(min-width: ${breakpoints[2]})`]: {
      display: "flex",
      padding: 3,
    },
  },
});

export const cross = style({
  display: "block",
  fill: vars.colors.white,
});
